import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwAudioService } from 'src/app/librarys/components/basic-components/sw-audio/sw-audio.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwVideoService } from 'src/app/librarys/components/basic-components/sw-video/sw-video.service';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
declare var $;
@Component({
  selector: 'app-material-add',
  templateUrl: './material-add.component.html',
  styleUrls: ['./material-add.component.css']
})
export class MaterialAddComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  //标头提示信息
  headerLoGo: string; 
  //绑定的表单数据
  resourceModel:any = {
    materialCategory: '',
    accessType:3,
    detailObj:{}
  }; 
  //保存按钮是否可点击
  clickEnable = true;
  // 素材类型下拉选项（文档、图像、音频、视频、链接）
  materialCategoryOptions:any = [];
  textTypeOptions:any = [];
  // 素材获取类型下拉选项
  accessTypeList:any = [{ id: 1, text: '文件导入'},{ id: 2, text: '网络抓取'},{ id: 3, text: '人工录入'}];
  // 封面图上传文件策略
  autoCode:string = '';
  // 已选择的标签数组
  selectedTags: any = [];
  selectedTags1: any = [];
  docTypeOptions:any = KmsEnum.docTypeOptions;
  // 时间月数据
  monthArr = new Array(12).fill("").map((item, index) => index + 1);
  // 时间天数据
  dayArr = new Array(31).fill('').map((item, index) => index + 1);
  // 当前知识库是否兼容模式
  isCompatibleMode = 1;
  // 所在资源云目录
  catalogOptions:any = [];
  constructor(
    private instanceModuleService: InstanceModuleService,
    private dictService: DictionaryService,
    private swVideoService: SwVideoService,
    private swAudioService: SwAudioService,
    private box: SwMassageBoxService,
    private kmsService: KmsService,
    private jwt: SwJwtService
  ) {
  }

  ngOnInit() {
    // 通过知识库标识拼接文件策略
    let kgDbInfo = JSON.parse(this.jwt.getToken('kgDbInfo'));
    let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : '';
    this.autoCode = kgCode ? KmsEnum.KMS_INSTANCE_IMG_RESOURCE + '_' + (kgCode.toUpperCase()) : '';
    this.isCompatibleMode = kgDbInfo ? kgDbInfo.isCompatibleMode : null;
    // 表单初始化
    this.clickLoca(this.param["upOrAdd"],this.param["selectedData"]);
    // 查询全部的资源云目录信息
    this.queryAllCatalogues();
  };

  //素材点击新增 或者 修改
  clickLoca(upOrAdd: string, selectedData: any) {
    //修改操作
    if (upOrAdd == "Edit") {
      //修改提示头
      this.headerLoGo = "编辑素材";
      this.materialCategoryOptions = this.instanceModuleService.getResourceTypeOptions();
      // 查询素材信息
      this.kmsService.queryMaterialById(selectedData.materialId).subscribe(
        data => {
          if (data["code"] == '200') {
            if(data.data){
              this.resourceModel = data.data;
              this.resourceModel.detailObj = data.data.documentInformation ? JSON.parse(data.data.documentInformation) : {};
              this.selectedTags = data.data.tags && data.data.tags.length>0 ? data.data.tags : [];
              this.selectedTags1 = this.resourceModel.detailObj.keywords && this.resourceModel.detailObj.keywords.length>0 ? this.resourceModel.detailObj.keywords : [];
              const i = this.materialCategoryOptions.find(e => e.id == this.resourceModel.materialCategory);
              this.textTypeOptions = i && i['childs'] ? i['childs'] : [];
            }else{
              this.box.danger('未查询到当前素材信息！');
            }
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    } else {
      this.headerLoGo = "新增素材";
      let fileTypes = this.instanceModuleService.getResourceTypeOptions();
      this.materialCategoryOptions = fileTypes.filter(e => e.id.indexOf('KGS_LINKDATA')>-1);
      this.textTypeOptions = [];
    }
  }

  // 素材类型下拉框改变时触发
  categoryChange(event){
    this.resourceModel.textType = '';
    const i = this.materialCategoryOptions.find(e => e.id == this.resourceModel.materialCategory);
    this.textTypeOptions = i && i['childs'] ? i['childs'] : [];
  }

  // 判断是否存在该属性
  hasAttr(key){
    const i = this.materialCategoryOptions.find(e => e.id == this.resourceModel.materialCategory);
    if(i && i.recordFileds.length>0){
      let attrs = i.recordFileds;
      if(this.resourceModel.textType && i.childs.length > 0){
        let t = i.childs.find(e => e.id == this.resourceModel.textType);
        if(t && t.recordFileds.length>0){
          attrs = t.recordFileds;
        }
      }
      return attrs.find(e => e.id == key);
    }else{
      return false;
    }
  }

  // 判断是否为外站链接数据
  isLinkData(){
    const materialCategory = this.resourceModel.materialCategory;
    return materialCategory && materialCategory.indexOf('KGS_LINKDATA')>-1;
  }

  // 上传头像成功的回调
  headImgAdd(event){
    if (event.length > 0) {
      const val = event[0].filePath + event[0].fileName;
      // 根据文件类型判断上传封面图还是资源图片
      if (this.resourceModel.materialCategory == "FILE_TYPE_PICTURE") {
        this.resourceModel.filePath = val;
        // 获取缩略图路径
        let index = event[0].fileName.lastIndexOf(".");
        let name =
          event[0].fileName.substring(0, index) +
          "_300@x." +
          event[0].fileSuffix;
        this.resourceModel.fileThumbnail = event[0].filePath + "THUMB/" + name;
      } else {
        this.resourceModel.fileThumbnail = val;
      }
    }
  }

  // 删除头像成功的回调
  headImgDelete(event){
    this.resourceModel.fileThumbnail = "";
    // 根据文件类型判断上传封面图还是资源图片
    if (this.resourceModel.materialCategory == "FILE_TYPE_PICTURE") {
      this.resourceModel.filePath = "";
    }
  }

  // 已选择标签发生变化时重新获取
  tagsChange(event){
    this.selectedTags = event;
  }

  // 已选择标签发生变化时重新获取
  tagsChange1(event){
    this.selectedTags1 = event;
  }

  // 播放音频或视频
  clickPlay(){
    if(this.resourceModel.filePath){
      if(this.resourceModel.materialCategory == 'FILE_TYPE_AUDIO'){
        this.swAudioService.openAudio(this.resourceModel.materialTitle, environment.staticFileUrl+this.resourceModel.filePath);
      }
      if(this.resourceModel.materialCategory == 'FILE_TYPE_VIDEO'){
        this.swVideoService.openVideo(this.resourceModel.materialTitle, environment.staticFileUrl+this.resourceModel.filePath);
      }
    }
  }

  // 提交
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      this.clickEnable = false;
      // 获取标签
      let tagIds = [];
      if(this.selectedTags.length>0){
        tagIds = this.selectedTags.map(el => el.tagId);
      }
      let params:any = JSON.parse(JSON.stringify(this.resourceModel));
      if(this.param["upOrAdd"] == 'Add'){
        params['approvalStatus'] = 0;     // 状态默认为待指派（质检状态） 
        params['textExtractStatus'] = params.materialCategory == 'FILE_TYPE_DOCUMENT' ? 3 : 0;  // 文字提取状态：人工创建的文档类型默认为已提取；其他类型默认为待提取；
        // params['pagesNum'] = params.materialCategory == 'FILE_TYPE_DOCUMENT' ? 1 : null;
        // params['materialText'] = params.materialCategory == 'FILE_TYPE_DOCUMENT' ? params['materialText'] : null;
      }else{
        params['fileSuffix'] = params['fileSuffix'] ? params['fileSuffix'] : this.instanceModuleService.getFileSuffix(params.materialCategory,params.filePath);
      }
      // 添加标签信息
      params['tagIds'] = tagIds;
      // 著录信息
      let obj:any = JSON.parse(JSON.stringify(params['detailObj']));
      let keys = Object.keys(obj);
      keys.forEach(e => {
        if(!this.hasAttr(e) && e != 'publicationTimeNote'){
          delete obj[e];
        }
      });
      if(this.hasAttr('keywords') && this.selectedTags1.length>0){
        let tags = [];
        this.selectedTags1.forEach(e => {
          tags.push({
            tagId: e.tagId,
            tagName: e.tagName
          })
        });
        obj.keywords = tags;
      }
      params['documentInformation'] = JSON.stringify(obj);
      delete params.tags;
      delete params.detailObj;
      // 保存基本信息和著录信息
      if(this.param["upOrAdd"] == 'Add'){
        this.kmsService.saveOrUpdateMaterial([params]).subscribe(
          data => {
            this.clickEnable = true;
            if(data.code == '200'){
              //抛出事件 提示 关闭模态框
              this.modal.toggle();
              this.callback.emit(true);
              this.updateESMaterialInfo(data.data);
              this.box.success('保存成功');
            }else{
              this.box.waring('素材信息保存失败！');
            }
          }
        );
      }else{
        this.kmsService.saveMaterialInfo(params).subscribe(
          data => {
            this.clickEnable = true;
            if(data.code == '200'){
              //抛出事件 提示 关闭模态框
              this.modal.toggle();
              this.callback.emit(true);
              this.updateESMaterialInfo([params.materialId]);
              this.box.success('保存成功');
            }else{
              this.box.waring('素材信息保存失败！');
            }
          }
        );
      }
    }
  }

  // 获取时间中的年月日
  getYearOrMonthOrDay(key, dateStr) {
    let data;
    if (!dateStr) {
      data = {
        year: "",
        month: "",
        day: "",
      };
    } else {
      const dateArr = dateStr.split("/");
      const len = dateArr.length;
      data = {
        year: len > 0 ? dateArr[0] : "",
        month: len > 1 ? dateArr[1] : "",
        day: len > 2 ? dateArr[2] : "",
      };
    }
    return data[key];
  }

  // 获取年号
  getTime(name) {
    let parent = $('input[name="' + name + '"]').parent();
    const value = parent.find(".year").val();
    if (value) {
      if (value > 1949) {
        this.resourceModel.detailObj.publicationTimeNote = `${value}年`;
      } else {
        this.kmsService.getInstanceTimeNoteByYear(value).subscribe((data) => {
          if (data.code == "200") {
            const res = data.data;
            this.resourceModel.detailObj.publicationTimeNote = res;
          } else {
            this.box.waring(data.msg);
          }
        });
      }
    }
  }

  // 将年月日拼接成字符串
  getDateStr(keyName) {
    let parent = $('input[name="' + keyName + '"]').parent();
    const yearValue = parent.find(".year").val();
    const monthValue = parent.find(".month").val();
    const dayValue = parent.find(".day").val();

    let res = this.instanceModuleService.validateTime(
      yearValue,
      monthValue,
      dayValue
    );
    this.resourceModel.detailObj.publicationTime = res.timeStr;
  }

  // 更新资源es信息
  updateESMaterialInfo(ids){
    if(ids.length == 0){
        return;
    }
    this.kmsService.updateESMaterialInfo({"materialIdList":ids}).subscribe(
      data => {
        if (data["code"] != 200) {
          this.box.danger(data.msg);
        }
      }
    )
  }

  // 查询所有的资源云目录信息
  queryAllCatalogues() {
    this.kmsService.queryAllCatalog().subscribe(
      res => {
        if (res.code == 200) {
          this.catalogOptions = res.data;
          this.catalogOptions = this.catalogOptions.sort((a, b) => { return a.sortNum - b.sortNum });
          this.catalogOptions.forEach(e => {
            e.id = e.catalogId;
            e.text = e.catalogName;
            e.pid = e.parentId;
          });
        }
      }
    )
  }
}
